import { Component, Input, OnInit, inject } from "@angular/core";
import { CareplusAgencyService } from "src/services/careplus-agency-service";
import { CareplusCompleteTxRequest } from "src/models/careplus-complete-tx-request";

@Component({
  selector: "app-agency-payment-success",
  templateUrl: "./agency-payment-success.component.html",
  styleUrls: ["./agency-payment-success.component.css"],
})
export class AgencyPaymentSuccessComponent implements OnInit {
  @Input() batchId!: number;
  @Input() paymentToken!: string;

  private _careplusAgencyService = inject(CareplusAgencyService);

  ngOnInit(): void {
    if (this.batchId && this.paymentToken) {
      this.completePayment(this.batchId, "SUCCESS", this.paymentToken);
    }
  }

  completePayment(batchId: number, status: string, paymentToken: string): void {
    const requestBody: CareplusCompleteTxRequest = {
      status: status,
      paymentToken: paymentToken,
    };

    this._careplusAgencyService.completeTx(batchId, requestBody).subscribe({});
  }
}
